import { useState } from "react";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@capacit-com/lara-law-shared-ui";
import { Button } from "@capacit-com/lara-law-shared-ui";
import { Input } from "@capacit-com/lara-law-shared-ui";
import { Plus } from "lucide-react";
import { TagType } from "@/models/tag/tag";

interface CreateTagPopoverProps {
  onCreateTag: (tagName: string, tagType: TagType) => void;
  tagType: TagType;
}

export function CreateTagPopover({
  onCreateTag,
  tagType,
}: CreateTagPopoverProps) {
  const [newTag, setNewTag] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  const handleCreateTag = () => {
    if (newTag.trim()) {
      onCreateTag(newTag.trim(), tagType);
      setNewTag("");
      setIsOpen(false);
    }
  };

  return (
    <Popover open={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger asChild>
        <Button
          onClick={() => setIsOpen(true)}
          variant={"link"}
          size={"sm"}
          className="!px-0 h-6 !text-xs"
        >
          <Plus className="size-3.5" />
          {tagType === TagType.Department
            ? "Opret ny afdeling"
            : "Opret nyt tag"}
        </Button>
      </PopoverTrigger>
      <PopoverContent
        className="w-80"
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            handleCreateTag();
          }
        }}
      >
        <div className="grid gap-4">
          <h4 className="font-medium leading-none">
            {tagType === TagType.Department ? "Ny afdeling" : "Nyt tag"}
          </h4>
          <div className="grid gap-2">
            <Input
              id="newTag"
              value={newTag}
              onChange={(e) => setNewTag(e.target.value)}
              placeholder={
                tagType === TagType.Department ? "Afdelingsnavn" : "Tag navn"
              }
            />
          </div>
          <Button onClick={handleCreateTag}>
            {tagType === TagType.Department ? "Opret afdeling" : "Opret tag"}
          </Button>
        </div>
      </PopoverContent>
    </Popover>
  );
}
